import { graphql } from 'gatsby';
import React from 'react';
import search from '../Filters/search';
import useExhibitorFilters from './exhibitorFilters';

/**
 * @param {readonly import('./exhibitorFilters').Exhibitor[]} items
 * @param {string} query
 */
export default function useExhbitorSearch(items, query) {
  const filterConfig = useExhibitorFilters();
  return React.useMemo(() => {
    if (!query) return items;
    return search(items, query, filterConfig.search || {});
  }, [items, query, filterConfig]);
}

export const fragment = graphql`
  fragment Search_Exhibitor on Exhibitor {
    __typename
    name
    countryName: country(full: true)
    region
    city
    stand {
      name: title
    }
  }
`;

/**
 * @typedef {{
 *  name: string;
 *  countryName: string | null;
 *  region: string | null;
 *  city: string | null;
 *  stand: { name: string | null };
 * }} Search_Exhibitor
 */
